import { OverviewProductStatusEnum } from '../../../ReceivementTypes'
import { KG_ACCEPT_TOLERANCE } from './validateAcceptedQuantity'

const PREC = 1000

export interface KgOverToleranceProduct {
  isKg?: boolean;
  status: OverviewProductStatusEnum;
  damageQuantity: number;
  usefulQuantity: number;
  expectedQuantity: number;
}

/**
 * Produto em kg recebido ACIMA da AR, porem dentro da margem tolerada
 * (recebido <= AR * (1 + KG_ACCEPT_TOLERANCE)).
 *
 * Nesse caso o excedente e imprecisao de balanca, nao divergencia real: o produto
 * nao deve ser sinalizado como divergente nem exigir segunda contagem. Aplica-se
 * somente a status QUANTIDADE_MAIOR (`HIGHER`); QUANTIDADE_MENOR e PRODUTO_ERRADO
 * permanecem divergentes.
 *
 * Math inteira escalada por PREC (anti-float-drift), igual a validateAcceptedQuantity.
 */
export const isKgOverWithinTolerance = ({
  isKg,
  status,
  damageQuantity,
  usefulQuantity,
  expectedQuantity,
}: KgOverToleranceProduct): boolean => {
  if (!isKg || status !== OverviewProductStatusEnum.HIGHER || expectedQuantity <= 0) {
    return false
  }

  const receivedInt = Math.round((damageQuantity + usefulQuantity) * PREC)
  const expectedInt = Math.round(expectedQuantity * PREC)
  const ceilingInt = Math.round(expectedQuantity * (1 + KG_ACCEPT_TOLERANCE) * PREC)

  return receivedInt > expectedInt && receivedInt <= ceilingInt
}
